module.exports = __webpack_public_path__ + "img/illuminati.4f547651.svg";